import React from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import { Card, Row, Col, Button, Drawer, Form, notification, Tooltip, Checkbox, Modal } from "antd";
import { TableComp, FormUtils as GetAllFormFields } from "sz-react-utils";
import Request, { API_URL, LAPI_URL } from "../../../../request";
import _ from 'lodash';
import async from 'async';
import BusinessProposalListFollowUp from "../../../../components/_utils/businessProposalListFollowUp";
import { RightsWrapper } from "../../../../components/_utils/utils";
import moment from "moment";

const dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY'

let proposalObj = {};
let userCheckBox = {}

class ReminderDetailsDrawer extends React.Component {
    state = {
        visible: true,
        modalOpen: false,
        templateData: ""
    }

    componentDidMount() {

    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    handleOk = () => {
        this.setState({ modalOpen: false, templateData: null })
    };
    handleCancel = () => {
        this.setState({ modalOpen: false, templateData: null })
    };

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 70)
    }

    render() {
        let { visible, modalOpen } = this.state;
        const columns = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                render: (text, record, index) => (
                    <span>{index + 1}</span>
                )
            },
            {
                title: 'Sent Date',
                key: 'sentDate',
                render: (text, record) => (
                    record.sentDate ? moment(record.sentDate).format(dateFormat) : moment(record.createdByUser.time).format(dateFormat)
                )
            },
            {
                title: 'Sent By',
                key: 'createdByUser.name'
            },
            {
                title: 'Mail Details ',
                key: 'templateData',
                render: (text, record) => (
                    <Button onClick={() => this.setState({ modalOpen: true, templateData: record.templateData })}>Show Details</Button>
                )
            }
        ]
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Reminder Records
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}>
                {
                    modalOpen ?
                        <Modal visible={modalOpen} onOk={this.handleOk} onCancel={this.handleCancel} footer={[
                            // <Button key="book" href={record.url} target='_blank' type='primary'>Book Service</Button>
                        ]}>
                            <div dangerouslySetInnerHTML={{ __html: this.state.templateData }} />
                        </Modal>

                        : null
                }
                <TableComp dataSource={this.props.reminders} columns={columns} ref={this.table} pagination={{
                    showSizeChanger: true,
                    defaultPageSize: 20,
                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                }} />
            </Drawer>
        )
    }
}

@Form.create()
class BusinessProposalReminder extends React.Component {
    state = {
        visible: true,
        templateData: [],
        templatesArr: [],
        mailLogoPath: null,
    }

    loadTemplates = async () => {
        let emailTemplates = await Request.getTemplatesForCommunication('University Business Proposal');
        let templates = []
        async.each(emailTemplates, (template) => {
            templates.push({ id: template._id, display: template.templateName })
        })
        this.setState({ templateData: emailTemplates, templatesArr: templates })
    }

    componentDidMount() {
        this.loadTemplates();
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 200)
    }


    handleSubmit = (e) => {
        e.preventDefault();
        let { form, recordIds } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            values.recordIds = recordIds
            values.mailLogoPath = this.state.mailLogoPath
            let response = await Request.sendBusinessProposalReminder(values)
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose();
        })
    }

    loadTemplateData = async (templateId) => {
        let { templateData } = this.state
        let { form: { setFieldsValue } } = this.props;
        let foundTemplate = templateData.find(obj => obj._id === templateId);
        if (foundTemplate && foundTemplate.mailLogo && foundTemplate.mailLogo.length) {
            this.setState({ mailLogoPath: `${API_URL}${foundTemplate.mailLogo[0].url}` })
        }
        if (foundTemplate) {
            setFieldsValue({ subject: foundTemplate.emailSubject, templateData: foundTemplate.templateData })
        }
    }

    render() {
        let { visible, templatesArr } = this.state
        let { form: { getFieldDecorator, setFieldsValue } } = this.props;
        const inputTypes = {
            fields: [
                {
                    label: 'Choose Template',
                    key: 'templateId',
                    type: 'select',
                    required: true,
                    options: templatesArr,
                    onChange: v => {
                        setFieldsValue({ templateId: v }, () => {
                            this.loadTemplateData(v)
                        })
                    }
                },
                {
                    label: 'Subject',
                    key: 'subject',
                    required: true
                },
                {
                    label: 'Template Body',
                    key: 'templateData',
                    required: true,
                    type: 'editor',
                    rows: 10,
                    height: "400px",
                }
            ]
        }
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Send University Business Proposal Reminder
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}
            >
                <Form onSubmit={this.handleSubmit}>
                    <GetAllFormFields getFieldDecorator={getFieldDecorator} inputSchema={inputTypes} apiurl={LAPI_URL} />
                    {
                        this.state.mailLogoPath ?
                            <div style={{ width: '100%', textAlign: 'center', marginTop: 20 }}>
                                <img style={{ width: "40%" }} src={this.state.mailLogoPath}></img>
                            </div>

                            : null
                    }
                    <Row style={{ marginTop: '20px' }}>
                        <Col span={8} />
                        <Col span={8}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{ marginBottom: 10 }}
                            >
                                Send
                            </Button>
                        </Col>
                        <Col span={8} />
                    </Row>
                </Form>

            </Drawer>
        )
    }
}

@Form.create()
class BusinessProposalDrawer extends React.Component {
    state = {
        visible: true,
        phoneCodes: [],
        countryArr: [],
        statesData: [],
        citiesData: [],
        templatesArr: [],
        templateData: [],
        mailLogoPath: null,
        loading: false,
        toEmail: '',
        showReminderEmailDrawer: false,
        recordIds: []
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 200)
    }

    loadCountries = () => {
        let params = {
            results: 100,
            sortField: "countryName",
            sortOrder: "ascend",
        };
        Request.getCountriesWithoutAuth({ ...params })
            .then((resp) => {
                let countryFieldArr = [];
                let phoneCodes = [];
                resp.data = resp.data.reduce((temp, vv) => {
                    countryFieldArr.push({ id: vv._id, display: vv.countryName });
                    if (vv.countryPhoneCode) {
                        phoneCodes.push({ id: vv.countryPhoneCode, display: vv.countryPhoneCode })
                    }
                    temp.push({ ...vv });
                    return temp;
                }, []);
                this.setState({ countryArr: countryFieldArr, phoneCodes: phoneCodes });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    loadStates = async id => {
        Request.loadStates(id)
            .then(daa => {
                daa.result = daa.result.reduce((total, val) => {
                    total.push({
                        id: val._id,
                        display: val.stateName
                    })
                    return total
                }, [])

                this.setState({ statesData: daa.result })
            })
            .catch(err => {
            })
    }

    loadTemplateData = async (templateId) => {
        let { templateData } = this.state
        let { form: { setFieldsValue } } = this.props;
        let foundTemplate = templateData.find(obj => obj._id === templateId);
        if (foundTemplate && foundTemplate.mailLogo && foundTemplate.mailLogo.length) {
            this.setState({ mailLogoPath: `${API_URL}${foundTemplate.mailLogo[0].url}` })
        }
        if (foundTemplate) {
            setFieldsValue({ subject: foundTemplate.emailSubject, templateData: foundTemplate.templateData })
        }
    }

    loadCities = async id => {
        Request.loadCities(id)
            .then(data => {
                data.result = data.result.reduce((total, val) => {
                    total.push({
                        id: val._id,
                        display: val.cityName
                    })
                    return total
                }, [])
                this.setState({ citiesData: data.result })
            })
            .catch(err => {
            })
    }

    loadTemplates = async () => {
        let emailTemplates = await Request.getTemplatesForCommunication('University Business Proposal');
        let templates = []
        async.each(emailTemplates, (template) => {
            templates.push({ id: template._id, display: template.templateName })
        })
        this.setState({ templateData: emailTemplates, templatesArr: templates })
    }


    async componentDidMount() {
        this.loadCountries();
        this.loadTemplates();
    }

    handleSubmit = (e) => {
        e.preventDefault();
        let { form } = this.props;
        let { mailLogoPath } = this.state;
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            if (mailLogoPath) {
                values.mailLogo = mailLogoPath
            }
            this.setState({ loading: true })
            let response = await Request.sendBusinessProposal(values);
            this.setState({ loading: false })
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose();
        })
    }

    render() {
        let { visible, countryArr, phoneCodes, statesData, citiesData, templateData, templatesArr } = this.state;
        let { form: { getFieldDecorator, setFieldsValue } } = this.props
        const inputTypes = {
            fields: [
                {
                    label: 'To Email',
                    key: 'toEmail',
                    required: true,
                    type: 'select',
                    options: [{ id: 'custom', display: 'Custom - Email to Any Recipient' }, { id: 'excel', display: 'Excel Data - Bulk Email' }],
                    onChange: v => {
                        this.setState({ toEmail: v }, () => {
                            setFieldsValue({ toEmail: v })
                        })
                    }
                },
                {
                    label: 'Contact Person\'s Name',
                    key: 'name',
                    placeholder: 'Contact Person\'s Name',
                    required: this.state.toEmail === 'custom' ? true : false,
                    hidden: this.state.toEmail === 'custom' ? false : true
                },
                {
                    label: 'Email',
                    key: 'email',
                    placeholder: 'Contact Person\'s Email',
                    required: this.state.toEmail === 'custom' ? true : false,
                    hidden: this.state.toEmail === 'custom' ? false : true
                },
                {
                    label: 'CC',
                    key: 'toCC',
                    placeholder: 'CC'
                },
                {
                    label: 'Reply To',
                    key: 'replyTo',
                    placeholder: 'Reply Email Address'
                },

                {
                    label: 'Country Code',
                    key: 'countryCode',
                    type: 'select',
                    showSearch: true,
                    options: phoneCodes,
                    hidden: this.state.toEmail === 'custom' ? false : true,
                    onChange: v => {
                        setFieldsValue({ countryCode: v })
                    }
                },
                {
                    label: 'Phone/Mobile Number',
                    key: 'phone',
                    showSearch: true,
                    placeholder: 'Phone/Mobile Number',
                    hidden: this.state.toEmail === 'custom' ? false : true,
                },
                {
                    label: 'University Name',
                    key: 'universityInstitutionName',
                    placeholder: 'University Name',
                    required: true,
                    required: this.state.toEmail === 'custom' ? true : false,
                    hidden: this.state.toEmail === 'custom' ? false : true,
                },
                {
                    label: 'Country',
                    key: 'countryId',
                    type: 'select',
                    showSearch: true,
                    options: countryArr,
                    required: true,
                    required: this.state.toEmail === 'custom' ? true : false,
                    hidden: this.state.toEmail === 'custom' ? false : true,
                    onChange: v => {
                        setFieldsValue({ countryId: v }, () => {
                            this.loadStates(v)
                        })

                    }
                },
                {
                    label: 'State',
                    key: 'stateId',
                    type: 'select',
                    showSearch: true,
                    options: statesData,
                    hidden: this.state.toEmail === 'custom' ? false : true,
                    onChange: v => {
                        setFieldsValue({ stateId: v }, () => {
                            this.loadCities(v)
                        })
                    }
                },
                {
                    label: "City",
                    key: 'cityId',
                    type: 'select',
                    showSearch: true,
                    options: citiesData,
                    hidden: this.state.toEmail === 'custom' ? false : true,
                    onChange: v => {
                        setFieldsValue({ cityId: v })
                    }
                },
                {
                    label: 'Reference/Source of Contact',
                    key: 'reference',
                    hidden: this.state.toEmail === 'custom' ? false : true,
                    placeholder: '“Source of contact like ICEF or General”',
                },
                {
                    label: 'Upload CSV File',
                    key: 'excelFile',
                    type: 'file',
                    hidden: this.state.toEmail === 'excel' ? false : true,
                    required: this.state.toEmail === 'excel' ? true : false,
                    prefixComp: <small>Download Sample File <a target="_blank" href={`${API_URL}/media/business-proposal-sample.csv`}>Here</a></small>
                },
                {
                    label: 'Choose Template',
                    key: 'templateId',
                    type: 'select',
                    required: true,
                    options: templatesArr,
                    onChange: v => {
                        setFieldsValue({ templateId: v }, () => {
                            this.loadTemplateData(v)
                        })
                    }
                },
                {
                    label: 'Subject',
                    key: 'subject',
                    required: true
                },
                {
                    label: 'Template Body',
                    key: 'templateData',
                    required: true,
                    type: 'editor'
                }
            ]
        }
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Send University Business Proposal
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}
            >
                <Card bordered={false}>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} apiurl={LAPI_URL} />
                        {
                            this.state.mailLogoPath ?
                                <div style={{ width: '100%', textAlign: 'center', marginTop: 20 }}>
                                    <img style={{ width: "40%" }} src={this.state.mailLogoPath}></img>
                                </div>

                                : null
                        }
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.state.loading}
                                >
                                    Send
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}


class BusinessProposals extends React.Component {
    state = {
        total: 0,
        showBusinessProposalDrawer: false,
        showFollowUp: false,
        recordId: null,
        userCheckBox: {},
        showReminderDetailsDrawer: false,
        reminderRecord: [],
        showDetailDrawer: false,
        templateData: ""
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let response = await Request.getBusinessProposalDetails(params);
            let employeesCheckBox = {}
            async.each(response.data, (dataItem) => {
                if (!employeesCheckBox[dataItem._id]) {
                    employeesCheckBox[dataItem._id] = {
                        itemId: dataItem._id,
                        isChecked: false
                    }
                }
            })
            userCheckBox = employeesCheckBox
            this.setState({ total: response.total, userCheckBox });
            return resolve(response)
        })
    }

    handleAdd = () => {
        this.setState({ showBusinessProposalDrawer: true })
    }

    handleSendReminders = () => {
        let userArr = _.filter(this.state.userCheckBox, (item) => {
            return item.isChecked;
        });
        if (userArr && userArr.length) {
            let recordIds = [];

            async.each(userArr, (user) => {
                recordIds.push(user.itemId)
            })
            this.setState({ showReminderEmailDrawer: true, recordIds: recordIds })
        } else {
            notification.error({
                message: "Please select atleast 1 Entry.",
            });
        }

    }

    closeBusinessProposal = () => {
        this.setState({ showBusinessProposalDrawer: false }, () => {
            this.table.current.reload();
        })
    }

    selectUser = (item, studentId) => {
        let cloneUserCheckBox = _.clone(this.state.userCheckBox);
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
        this.setState({ userCheckBox: cloneUserCheckBox });
    };

    closeReminderEmailDrawer = () => {
        this.setState({ showReminderEmailDrawer: false, recordIds: [] }, () => {
            this.table.current.reload()
        })
    }

    closeReminderDetailDrawer = () => {
        this.setState({ showReminderDetailsDrawer: false, reminderRecord: [] }, () => {
            this.table.current.reload();
        })
    }

    sendReminderEmail = (recordId) => {
        this.setState({ showReminderEmailDrawer: true, recordIds: [recordId] })

    }


    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    openFollowUps = (record) => {
        proposalObj = {
            _id: record._id,
            name: record.universityInstitutionName
        }
        this.setState({ showFollowUp: true });
    };

    showRemindersSent = (reminderRecord) => {
        this.setState({ showReminderDetailsDrawer: true, reminderRecord: reminderRecord.reminders })
    }

    closeFollowUps = () => {
        this.setState({ showFollowUp: false }, () => {
            proposalObj = {}
            this.table.current.reload();
        });
    }

    deleteProposal = async (recordId) => {
        let response = await Request.deleteBusinessProposal(recordId);
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table.current.reload();
    }

    handleOk = () => {
        this.setState({ showDetailDrawer: false, templateData: null })
    };
    handleCancel = () => {
        this.setState({ showDetailDrawer: false, templateData: null })
    };



    async componentDidMount() {

    }

    render() {
        const { total, showBusinessProposalDrawer, showReminderDetailsDrawer, reminderRecord, showReminderEmailDrawer, showFollowUp, recordId } = this.state
        const columns = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                width: 80,
                render: (text, record, index) => (
                    <span>{index + 1}</span>
                )
            },
            {
                title: "Action",
                key: 'operation',
                width: 140,
                render: (text, record) => (
                    <div>
                        <RightsWrapper myRight={"BusinessProposalsFollowUps.view"}>
                            <Tooltip title="FollowUp">
                                <Button
                                    size={"small"}
                                    shape="circle"
                                    onClick={() => this.openFollowUps(record)}
                                    icon="calendar"
                                />
                            </Tooltip>
                        </RightsWrapper>
                        <RightsWrapper myRight={"BusinessProposals.delete"}>
                            <Tooltip title="Delete University Proposal">
                                <Button style={{ marginLeft: 5 }} size="small" shape="circle" icon="delete" onClick={() => this.deleteProposal(record._id)} />
                            </Tooltip>
                        </RightsWrapper>
                        <Tooltip title="Send Reminder Email">
                            <Button style={{ marginLeft: 5 }} size="small" shape="circle" icon="forward" onClick={() => this.sendReminderEmail(record._id)} />
                        </Tooltip>
                        <Checkbox style={{ marginLeft: 5 }} key={record._id}
                            checked={
                                userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false
                            }
                            onChange={(y) => {
                                this.selectUser(y, record._id);
                            }}
                        />
                    </div>
                )
            },
            {
                title: 'Date',
                key: 'sentDate',
                width: 80,
                searchTextName: `Date:- ${dateFormat}`,
                filterRegex:true,
                render: (text, record) => (
                    record.reminders && record.reminders.length > 0 ? moment(record.reminders[record.reminders.length - 1].sentDate).format(dateFormat) : moment(record.createdByUser.time).format(dateFormat)
                )
            },
            {
                title: 'Template',
                key: 'templateData',
                width: 120,
                render: (text, record) => (
                    <Button onClick={() => this.setState({ showDetailDrawer: true, templateData: record.templateData })}>View Detail</Button>
                )
            },
            {
                title: 'Recipient Name',
                key: 'name',
                searchTextName: 'Recipient Name',
                width: 160
            },
            {
                title: 'Recipient Email',
                key: 'email',
                searchTextName: 'Recipient Email',
                width: 160
            },
            {
                title: 'Recipient Phone',
                key: 'phone',
                searchTextName: 'Recipient Phone',
                width: 150,
                render: (text, record) => (
                    <span>{record.countryCode}-{record.phone}</span>
                )
            },
            {
                title: 'University Name',
                key: 'universityInstitutionName',
                searchTextName: 'University Name',
                width: 150
            },
            {
                title: 'Country Name',
                key: 'countryName',
                searchTextName: 'Country Name',
                width: 150
            },
            {
                title: 'State Name',
                key: 'stateName',
                searchTextName: 'State Name',
                width: 120
            },
            {
                title: 'City Name',
                key: 'cityName',
                searchTextName: 'City Name',
                width: 120
            },
            {
                title: 'Reference',
                key: 'reference',
                searchTextName: 'Reference',
                width: 120
            },
            {
                title: 'Reminders',
                key: 'reminders',
                width: 120,
                render: (text, record) => (
                    <span><a onClick={() => this.showRemindersSent(record)}>{record && record.reminders ? record.reminders.length : 0}</a></span>
                )
            }
        ]

        return (
            <PageHeaderWrapper title={`Business Proposals: ${total}`}>
                {
                    showReminderDetailsDrawer ?
                        <ReminderDetailsDrawer reminders={reminderRecord} onClose={this.closeReminderDetailDrawer} />
                        : null
                }
                {
                    showReminderEmailDrawer ?
                        <BusinessProposalReminder recordIds={this.state.recordIds} onClose={this.closeReminderEmailDrawer} />
                        : null
                }
                {
                    showBusinessProposalDrawer ?
                        <BusinessProposalDrawer onClose={this.closeBusinessProposal} />
                        : null
                }
                {
                    showFollowUp ?
                        <BusinessProposalListFollowUp data={proposalObj} onClose={this.closeFollowUps} />
                        : null
                }
                {
                    this.state.showDetailDrawer ?
                        <Modal visible={this.state.showDetailDrawer} onOk={this.handleOk} onCancel={this.handleCancel} footer={[
                            // <Button key="book" href={record.url} target='_blank' type='primary'>Book Service</Button>
                        ]}>
                            <div dangerouslySetInnerHTML={{ __html: this.state.templateData }} />
                        </Modal>

                        : null
                }
                <Card bordered={true}>
                    <Row gutter={16}>
                        <RightsWrapper myRight={"BusinessProposals.add"}>
                            <Col span={2}>
                                <div >
                                    <Button onClick={this.handleAdd}>Compose</Button>
                                </div>
                            </Col>
                        </RightsWrapper>
                        <Col span={2}>
                            <div >
                                <Button onClick={this.handleSendReminders}>Send Reminders</Button>
                            </div>
                        </Col>
                        <RightsWrapper myRight={"Template.view"}>
                            <Col span={2}>
                                <div style={{marginLeft:40}}>
                                    <Button type="primary" href="/template/all-templates" target="_blank">Templates</Button>
                                </div>
                            </Col>
                        </RightsWrapper>
                    </Row>
                </Card>
                <Card bordered={true} style={{ marginTop: 10 }}>
                    <TableComp extraProps={{ scroll: { x: 900 } }} apiRequest={this.apiRequest} columns={columns} ref={this.table} pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 20,
                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                    }} />
                </Card>
            </PageHeaderWrapper>
        )
    }
}


const mapStateToProps = ({ global }) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BusinessProposals)